import classNames                                             from 'classnames';
import React, { FC, ReactNode }                               from 'react';
import { Header, Icon, Message, MessageProps, SemanticICONS } from 'semantic-ui-react';

interface BigFriendlyMessageProps extends MessageProps {
	icon?: SemanticICONS,
	title?: string,
	content?: ReactNode,
}

const defaultProps: BigFriendlyMessageProps = {
	icon:    'check circle',
	title:   null,
	content: null,
	info:    true,
}

const BigFriendlyMessage: FC<BigFriendlyMessageProps> = ( props ) => {
	
	let { icon, title, content, children, className, ...messageProps } = props;
	
	return (
		
		<Message className={ classNames( 'text-center fade-in', className ) } { ...messageProps }>
			<div className={ 'padding-lg' }>
				
				{ props.icon && (
					<div className={ 'padding-md-vertical' }>
						<Icon name={ props.icon } size={ 'huge' }/>
					</div>
				) }
				
				{ props.title && <Header as={ 'h3' } content={ props.title }/> }
				{ props.content && <p>{ props.content }</p> }
				
				{ props.children }
			
			</div>
		</Message>
	);
};

BigFriendlyMessage.defaultProps = defaultProps;

export { BigFriendlyMessage }
